<template>
  <div class="update-address-box">
    <el-row :gutter="20">
      <el-col :lg="12">
        <el-form
          v-show="!isResult"
          ref="form"
          :model="formState"
          :rules="formrules"
          label-width="auto"
        >
          <div class="text">
            恭喜贵单位获得文创纪念品一份！请于8月15日之前在本页面提交收件信息，我们会将纪念品在本月底前邮寄到您的单位~
            *若过期未提交或信息提交错误者，将视为自动放弃，我们不提供联系及补发哦！
          </div>
          <el-form-item label="排名">
            <el-input
              placeholder=""
              :maxLength="16"
              v-model="formState.rank"
              readonly
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="username">
            <el-input
              placeholder="请填写姓名"
              :maxLength="16"
              v-model="formState.username"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input
              placeholder="请填写手机号"
              v-model="formState.phone"
            ></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input
              placeholder="请填写地址"
              v-model="formState.address"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button :loading="btnLoading" type="primary" @click="onSubmit"
              >提交</el-button
            >
          </el-form-item>
        </el-form>
        <el-result
          v-show="isResult"
          icon="success"
          title="提交成功"
          subTitle=""
        >
          <template slot="extra"> </template>
        </el-result>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ORGAN_RANK } from "@/constant/index";
export default {
  data() {
    return {
      formState: {
        username: "",
        phone: "",
        address: "",
        rank: "",
      },
      formrules: {
        username: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            pattern: /^1[3456789]\d{9}$/gi,
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: "请输入地址",
            trigger: "blur",
          },
        ],
      },
      btnLoading: false,
      isResult: false,
      rankInfo: {
        is_address: 0,
        rank_num: 0,
      },
    };
  },
  created() {
    let rankInfo = JSON.parse(sessionStorage.getItem(ORGAN_RANK));
    // console.log(rankInfo);
    this.rankInfo = rankInfo;
    this.formState.rank = rankInfo.rank_num;
    this.getAddressData();
  },
  mouted() {},
  methods: {
    async onSubmit() {
      try {
        await this.$refs.form.validate();
        this.btnLoading = true;
        await this.$api.fetchAdminUpdateAddress({
          params: {
            token: localStorage.getItem("admin-token"),
          },
          data: {
            ...this.formState,
          },
        });
        this.isResult = true;
      } catch (err) {
        console.error(err);
      } finally {
        this.btnLoading = false;
      }
    },
    async getAddressData() {
      try {
        let res = await this.$api.fetchAdminGetAddress({
          params: {
            token: localStorage.getItem("admin-token"),
          },
        });
        console.log(res);
        if (res.data) {
          this.formState = {
            username: res.data.username,
            phone: res.data.phone,
            address: res.data.address,
            rank: res.data.rank,
          };
        }
      } catch (err) {}
    },
  },
};
</script>
<style scoped lang="scss">
.update-address-box {
  padding: 30px 0px;
  .text {
    line-height: 1.6;
    color: #f40;
    margin: 0 0 30rpx 0;
  }
}
</style>
